import { TemperatureFactory } from './temperatureFactory';

import type {
  TemperatureEntity,
  TemperaturePropsPub,
  TemperaturePropsPvt,
} from './temperatureEntity';
import type { TemperatureIRepository } from './temperatureIRepository';
import type { EntityDataPubType } from '@/infra/appsync';
import type { TemperatureJsonPub, TemperatureJsonPvt } from '@/types/domain/temperature/entities/temperatureEntity';

import { AppsyncRepository } from '@/domain/appsyncRepository';
import {
  EntityName,
} from '@/infra/appsync';

export class TemperatureRepository extends AppsyncRepository<
  TemperatureEntity,
  TemperaturePropsPvt,
  TemperatureJsonPvt,
  TemperaturePropsPub,
  TemperatureJsonPub
> implements TemperatureIRepository {
  private factory = new TemperatureFactory();

  protected get entityName(): EntityName {
    const name: EntityName = EntityName.WagakoAppTemperatureTemperatureEntity;
    return name;
  }

  /**
   * DBデータをEntityに変換
   * @param props DBデータ
   * @returns Entity
   */
  protected createFromEntityType = (
    props: EntityDataPubType,
  ) => this.factory.createFromEntityType(props);
}
